




















import { Component, Prop, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import { IBusinessType } from '@/models/business';
import { isRemoteLoading } from '@/utils/remote-loading';

@Component({
  components: {
    FilledButton
  }
})
export default class Success extends Vue {
  @Prop() rewardsType!: IBusinessType.ONLINE | IBusinessType.INSTORE;

  get tPrefix() {
    return `modals.toggleRewards.success`;
  }

  get tPrefixType() {
    return `${this.tPrefix}.${this.rewardsType}`;
  }

  onSecondaryClick() {
    this.$emit('close');
    this.$router.push('/coin/loyalty');
    if (isRemoteLoading()) {
      window.parent.postMessage(
        {
          type: 'portal-router-push',
          data: { path: '/my-programs/settings/loyalty-program' }
        },
        '*'
      );
    }
  }

  onPrimaryClick() {
    this.$emit('close');
  }
}
